









import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ExpressionKinds, IDateCalculateBehavior, IDateCalculateItem, IDateCalculateObject, instanceOfIDateCalculateNumber, TextObjectKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { CalculateObjectEditor, TextObjectEditor, DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";

@Component
export default class DateCalculateBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: IDateCalculateBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateCalculateBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  @Prop()
  currentObjectId: number;

  get items(): IDateCalculateItem[] {
    return this.readPropertyOrDefault(s => s.items, []);
  }

  set items(value: IDateCalculateItem[]) {
    this.writePropertyWhenValid(s => s.items = value);
  }

  get baseDateObjectItems(): IDateCalculateItem[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => o.objectTypeName().getValue() === "date"
        && (o as DateObjectEditor).isDate().getValue()
        && !!this.getIDateCalculateItemName(o)
        && !!o.id().getValue()　&& !!this.currentObjectId && o.id().getValue() !== this.currentObjectId)
      .select(o => this.toIDateCalculateItem(o)).toArray();
  }

  get settableItems(): IDateCalculateItem[] {
    return this.textObjectItems.concat(this.scriptObjectItems).concat(this.calculateDateObjectItems);
  }

  get textObjectItems(): IDateCalculateItem[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => o.objectTypeName().getValue() === "text" 
        && !!this.getIDateCalculateItemName(o)
        && (o as TextObjectEditor).objectKind().getValue() !== TextObjectKinds.DesignatedDoctorNumber)
      .select(o => this.toIDateCalculateItem(o)).toArray();
  }

  get scriptObjectItems(): IDateCalculateItem[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => Enumerable.from(this._scriptObjNames).contains(o.objectTypeName().getValue())
        && !!o.name().getValue())
      .select(o => this.toIDateCalculateItem(o)).toArray();
  }
  private _scriptObjNames = ["text", "script", "scriptlink"];

  // 期間日数のオブジェクト
  get calculateDateObjectItems(): IDateCalculateItem[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => o.objectTypeName().getValue() === "calculate" 
        && !!o.name().getValue()
        && (o as CalculateObjectEditor).kind().getValue() === ExpressionKinds.DateDuration)
        .select(o => this.toIDateCalculateItem(o)).toArray();
  }

  private toIDateCalculateItem(object: IFormatObjectEditable): IDateCalculateItem {
    return {
      isObject: true,
      reference: {
        type: object.objectTypeName().getValue(),
        key: this.getIdDateCalculateItemKey(object),
        itemType: "1",
        option: (object.objectTypeName().getValue() === "calculate") ? "3" : "1",
        operator: "1",
        name: this.getIDateCalculateItemName(object),
        id: object.id().getValue(),
      },
    };
  }

  private getIdDateCalculateItemKey(object: IFormatObjectEditable): string {
    return object.hisInformationKey().isEditable()
      ? object.hisInformationKey().getValue()
      : object.name().getValue();
  }

  private getIDateCalculateItemName(object: IFormatObjectEditable): string {
    return object.hisInformationKey().isEditable()
      ? object.getHisInformationName()
      : object.name().getValue();
  }

  private fillCalculateItemName(settableItems: IDateCalculateItem[], items: IDateCalculateItem[]): IDateCalculateItem[] {
    Enumerable.from(items).forEach(i => {
      if (!instanceOfIDateCalculateNumber(i.reference)) {
        const target = Enumerable.from(settableItems)
          .firstOrDefault(s => !instanceOfIDateCalculateNumber(s.reference) 
            && (i.reference as IDateCalculateObject).key === s.reference.key);
        if (!!target) {
          i.reference.name = (target.reference as IDateCalculateObject).name;
        } 
      }
    });
    return items;
  }

  async showDateCalculateEditDialog() {
    const dialog = this.commonComponents.getDialogs().getDateCalculateEditDialog();
    // TODO 引数設定
    const items = this.fillCalculateItemName(this.settableItems, this.items);
    const calculateItems = await dialog.show(this.baseDateObjectItems, this.settableItems, items);
    if (!calculateItems) { return; }
    this.items = calculateItems;
  }
}
